/**
 * An interface that routes a handler name to a function.
 * Includes a default function
 */
export interface Handlers {
    [handlerName: string] : (...args: string[]) => void;
    default: (...args: string[]) => void;
}

/**
 * A class for handling messages on the Window
 */
export default class VibesListener {
    private readonly window: Window;
    private readonly handlers: Handlers;

    constructor(window: Window, handlers: Handlers) {
        this.window = window;
        this.handlers = handlers;
    }

    /**
     * Adds a listener for the "message" event on the window, expecting the message
     * format to have an "action" and "args" key, and routes to the appropriate handler
     */
    init() {
        this.window.addEventListener('message', (e) => {
            if (this.window.origin != e.origin) {
                return;
            }

            if (!e.data.source || e.data.source != 'Vibes') {
               return;
            }

            if (!e.data.action) {
                throw new Error('Event posted to Vibes sent to without valid action');
            }

            const args = e.data.args;

            if (!Array.isArray(args)) {
              throw new Error(`Action ${e.data.action} posted to Vibes sent to without valid args`);
            }

            if (e.data.action in this.handlers) {
                this.handlers[e.data.action](...args);
            } else {
                this.handlers.default(...args);
            }
        });
    }
}
